module.exports = __webpack_public_path__ + "img/homepage-haulage.bf1199ea.jpg";